<template id="filtres">
  <div class="form-group filtres-condamnation facet-wrap">
    <label for="filtre_par_type_infraction">Type de condamnation</label>
    <select
      id="filtre_par_type_infraction"
      class="form-control form-control-sm"
      v-model="type_condamnation_choix"
      @change="onChangeTypeChoix()"
    >
      <option id="alimentation" value="alimentation">
        Établissement alimentaire
      </option>
      <option id="animal" value="animal">Santé et bien-être animal</option>
    </select>
  </div>

  <div class="form-group filtres-condamnation facet-wrap">
    <label for="type_entreprise">Type d'établissement</label>
    <!-- Option pour Alimentation -->
    <select
      v-if="type_condamnation == 'alimentation'"
      id="type_entreprise-aliment"
      class="form-control form-control-sm"
      v-model="typeCond"
      @change="onChangeType()"
    >
      <option id="tous-alimentation" selected="selected" value="all">
        Tous
      </option>
      <option value="1">Aquatique</option>
      <option value="0">Autres</option>
      <option value="20">Détail</option>
      <option value="3">Eaux et breuvages</option>
      <option value="99">Générale</option>
      <option value="5">Lait</option>
      <option value="6">Miel</option>
      <option value="4">Érable</option>
      <option value="2">Produits carnés</option>
      <option value="8">Production de végétaux</option>
      <option value="21">Restauration</option>
    </select>
    <!-- Option pour Bien-être animal -->
    <select
      v-if="type_condamnation == 'animal'"
      id="type_entreprise-animal"
      class="form-control form-control-sm"
      v-model="typeCond"
      @change="onChangeType()"
    >
      <option id="tous-bien-etre-animal" selected="selected" value="all">
        Tous
      </option>
      <option value="2">Produits carnés</option>
      <option value="5">Lait</option>
      <option value="32">Bien-être animal</option>
      <option value="31">Santé animal</option>
    </select>
  </div>

  <div class="form-group filtres-condamnation facet-wrap">
    <label for="filtre_par_poursuivant">Poursuivant</label>
    <select
      id="filtre_par_poursuivant"
      class="form-control form-control-sm"
      @change="onChangePoursuivant()"
    >
      <option value="all">Tous</option>
      <option value="VILLE DE MONTREAL">Cour municipale de Montréal</option>
      <option value="MAPAQ">Palais de justice de Québec</option>
    </select>
  </div>

  <div class="form-group filtres-condamnation facet-wrap">
    <!-- test pour date partir du / jusqu'au -->
    <div class="d-flex align-items-baseline mb-2">
      <legend class="mr-4 mb-0">Date de publication</legend>
    </div>
    <div class="row selectors">
      <div class="col-sm-6">
        <label class="sous-label" for="publication-from">À partir du</label>

        <input
          @change="getDate1"
          type="date"
          class="form-control form-control-sm p2 from selector"
          id="publication-from"
          placeholder="AAAA-MM-JJ"
          aria-describedby="publication-from-selector-help"
        />
        <div class="error d-none mt-2" aria-live="assertive" role="alert">
          <span class="sr-only">Erreur</span>
          Le format de la date est invalide
        </div>
      </div>

      <div class="col-sm-6">
        <label class="sous-label"  for="publication-to">Jusqu'au</label>

        <input
          @change="getDate2"
          type="date"
          class="form-control form-control-sm p2 to selector"
          id="publication-to"
          placeholder="AAAA-MM-JJ"
          aria-describedby="publication-to-selector-help"
        />
        <div class="error d-none mt-2" aria-live="assertive" role="alert">
          <span class="sr-only">Erreur</span>
          Le format de la date est invalide
        </div>
      </div>
    </div>
  </div>

  <div class="form-group filtres-condamnation facet-wrap">
    <!-- test pour date partir du / jusqu'au -->
    <div class="d-flex align-items-baseline mb-2">
      <legend class="mr-4 mb-0">Date de l'infraction</legend>
    </div>
    <div class="row selectors">
      <div class="col-sm-6">
        <label class="sous-label"  for="infraction-from">À partir du</label>

        <input
          @change="getDate3"
          type="date"
          class="form-control form-control-sm p2 from selector"
          id="infraction-from"
          placeholder="AAAA-MM-JJ"
          aria-describedby="infraction-from-selector-help"
        />
        <div class="error d-none mt-2" aria-live="assertive" role="alert">
          <span class="sr-only">Erreur</span>
          Le format de la date est invalide
        </div>
      </div>

      <div class="col-sm-6">
        <label class="sous-label"  for="infraction-to">Jusqu'au</label>

        <input
          @change="getDate4"
          type="date"
          class="form-control form-control-sm p2 to selector"
          id="infraction-to"
          placeholder="AAAA-MM-JJ"
          aria-describedby="infraction-to-selector-help"
        />
        <div class="error d-none mt-2" aria-live="assertive" role="alert">
          <span class="sr-only">Erreur</span>
          Le format de la date est invalide
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiltreCond',
  components: {},
  emits: [
    'filtreType',
    'filtreTypeChoix',
    'filtreDate1',
    'filtreDate2',
    'filtreDate3',
    'filtreDate4',
    'filtrePoursuivant',
  ],
  props: {
    type_condamnation: {
      type: String,
    },
  },
  data() {
    return {
      typeCond: 'all',
      type_condamnation_choix: 'all',
    };
  },
  methods: {
    onChangeType() {
      let typeCond = this.typeCond;
      this.$emit('filtreType', typeCond);
    },
    onChangeTypeChoix() {
      let type_condamnation_choix = this.type_condamnation_choix;
      this.$emit('filtreTypeChoix', type_condamnation_choix);
      this.$emit('filtreType', 'all');
      this.typeCond = 'all';
    },
    getDate1() {
      let date = document.getElementById('publication-from').value;
      let date1 = new Date(date.replace(/-/g, '/')).getTime();
      this.$emit('filtreDate1', date1, date);
    },
    getDate2() {
      let date = document.getElementById('publication-to').value;
      let date2 = new Date(date.replace(/-/g, '/')).getTime();
      this.$emit('filtreDate2', date2, date);
    },
    getDate3() {
      let date = document.getElementById('infraction-from').value;
      let date3 = new Date(date.replace(/-/g, '/')).getTime();
      this.$emit('filtreDate3', date3, date);
    },
    getDate4() {
      let date = document.getElementById('infraction-to').value;
      let date4 = new Date(date.replace(/-/g, '/')).getTime();
      this.$emit('filtreDate4', date4, date);
    },
    onChangePoursuivant() {
      let poursuivant = document.getElementById('filtre_par_poursuivant').value;
      this.$emit('filtrePoursuivant', poursuivant);
    },
  },
  computed: {},
  created() {},
};
</script>
